const scoreData = {
  northAmericanBenefitSolutions: {
    40: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.12276, 0.12402, 0.12528, 0.12654, 0.1278,
      0.12906,
    ],
    41: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0.0993, 0.12276, 0.12402, 0.12528, 0.12654,
      0.1278, 0.12906,
    ],
    42: [
      0, 0, 0, 0, 0, 0, 0, 0, 0.0975, 0.10005, 0.12366, 0.12492, 0.12618,
      0.12744, 0.1287, 0.12996,
    ],
    43: [
      0, 0, 0, 0, 0, 0, 0, 0.09345, 0.0981, 0.10065, 0.12438, 0.12564, 0.1269,
      0.12816, 0.12942, 0.13068,
    ],
    44: [
      0, 0, 0, 0, 0, 0, 0.0906, 0.0942, 0.09855, 0.1011, 0.12492, 0.12618,
      0.12744, 0.1287, 0.12996, 0.13122,
    ],
    45: [
      0, 0, 0, 0, 0, 0.0858, 0.0918, 0.09465, 0.09885, 0.1011, 0.12492, 0.12618,
      0.12744, 0.1287, 0.12996, 0.13122,
    ],
    46: [
      0, 0, 0, 0, 0.06396, 0.08595, 0.0918, 0.0948, 0.09885, 0.1011, 0.12492,
      0.12618, 0.12744, 0.1287, 0.12996, 0.13122,
    ],
    47: [
      0, 0, 0, 0.06108, 0.0648, 0.0867, 0.09255, 0.0954, 0.099, 0.1014, 0.12528,
      0.12654, 0.1278, 0.12906, 0.13032, 0.13158,
    ],
    48: [
      0, 0, 0.05832, 0.06192, 0.06576, 0.0873, 0.0933, 0.09615, 0.0996, 0.102,
      0.12618, 0.12744, 0.1287, 0.12996, 0.13122, 0.13266,
    ],
    49: [
      0, 0.0558, 0.05916, 0.06276, 0.0666, 0.0882, 0.09405, 0.0969, 0.10005,
      0.10275, 0.12708, 0.12834, 0.1296, 0.13086, 0.1323, 0.13356,
    ],
    50: [
      0.0534, 0.05664, 0.06, 0.0636, 0.06744, 0.0894, 0.0948, 0.09765, 0.1005,
      0.1035, 0.12798, 0.12924, 0.1305, 0.13176, 0.1332, 0.13446,
    ],
    51: [
      0.05388, 0.05712, 0.06048, 0.0642, 0.06804, 0.09015, 0.09555, 0.0984,
      0.10125, 0.1044, 0.12906, 0.13032, 0.13158, 0.13284, 0.13428, 0.13554,
    ],
    52: [
      0.05424, 0.05748, 0.06096, 0.06468, 0.06852, 0.09075, 0.0963, 0.09915,
      0.10215, 0.10515, 0.12996, 0.13122, 0.13266, 0.13392, 0.13518, 0.13662,
    ],
    53: [
      0.05472, 0.05796, 0.06144, 0.06516, 0.069, 0.0915, 0.09705, 0.0999,
      0.1029, 0.10605, 0.13104, 0.1323, 0.13356, 0.135, 0.13626, 0.1377,
    ],
    54: [
      0.05508, 0.05844, 0.06192, 0.06564, 0.0696, 0.09225, 0.0978, 0.10065,
      0.10365, 0.1068, 0.13194, 0.13338, 0.13464, 0.13608, 0.13734, 0.13878,
    ],
    55: [
      0.05556, 0.05892, 0.0624, 0.06612, 0.07008, 0.09285, 0.09855, 0.1014,
      0.10455, 0.10755, 0.13302, 0.13428, 0.13572, 0.13698, 0.13842, 0.13986,
    ],
    56: [
      0.05604, 0.0594, 0.063, 0.06684, 0.0708, 0.09375, 0.09945, 0.10245,
      0.10545, 0.1086, 0.13428, 0.13554, 0.13698, 0.13842, 0.13968, 0.14112,
    ],
    57: [
      0.05664, 0.06, 0.0636, 0.06744, 0.0714, 0.09465, 0.10035, 0.10335, 0.1065,
      0.10965, 0.13554, 0.13698, 0.13824, 0.13968, 0.14112, 0.14238,
    ],
    58: [
      0.05712, 0.0606, 0.0642, 0.06804, 0.07212, 0.09555, 0.10125, 0.1044,
      0.1074, 0.1107, 0.1368, 0.13824, 0.1395, 0.14094, 0.14238, 0.14382,
    ],
    59: [
      0.0576, 0.06108, 0.0648, 0.06864, 0.07284, 0.09645, 0.1023, 0.1053,
      0.10845, 0.11175, 0.13806, 0.1395, 0.14094, 0.1422, 0.14364, 0.14508,
    ],
    60: [
      0.06216, 0.06588, 0.06984, 0.07404, 0.07848, 0.10395, 0.11025, 0.11355,
      0.11685, 0.12045, 0.14886, 0.1503, 0.15192, 0.15336, 0.1548, 0.15642,
    ],
    61: [
      0.06312, 0.06696, 0.07092, 0.07524, 0.0798, 0.1056, 0.11205, 0.11535,
      0.1188, 0.1224, 0.1512, 0.15282, 0.15426, 0.15588, 0.1575, 0.15894,
    ],
    62: [
      0.0642, 0.06804, 0.07212, 0.07644, 0.081, 0.1074, 0.11385, 0.11715,
      0.12075, 0.12435, 0.15372, 0.15516, 0.15678, 0.1584, 0.16002, 0.16146,
    ],
    63: [
      0.06516, 0.06912, 0.0732, 0.07764, 0.08232, 0.10905, 0.11565, 0.1191,
      0.1227, 0.1263, 0.15606, 0.15768, 0.1593, 0.16092, 0.16254, 0.16416,
    ],
    64: [
      0.06624, 0.0702, 0.0744, 0.07884, 0.08364, 0.1107, 0.11745, 0.1209,
      0.1245, 0.12825, 0.15858, 0.1602, 0.16182, 0.16344, 0.16506, 0.16668,
    ],
    65: [
      0.0672, 0.07128, 0.07548, 0.08004, 0.08484, 0.1125, 0.11925, 0.12285,
      0.12645, 0.1302, 0.16092, 0.16254, 0.16416, 0.16596, 0.16758, 0.1692,
    ],
    66: [
      0.06792, 0.072, 0.07632, 0.08088, 0.08568, 0.11355, 0.12045, 0.12405,
      0.1278, 0.13155, 0.16254, 0.16416, 0.16596, 0.16758, 0.1692, 0.171,
    ],
    67: [
      0.06864, 0.07272, 0.07704, 0.08172, 0.08664, 0.11475, 0.12165, 0.12525,
      0.129, 0.1329, 0.16416, 0.16596, 0.16758, 0.1692, 0.171, 0.17262,
    ],
    68: [
      0.06924, 0.07344, 0.07776, 0.08244, 0.08748, 0.1158, 0.12285, 0.12645,
      0.13035, 0.13425, 0.16578, 0.16758, 0.1692, 0.17082, 0.17262, 0.17424,
    ],
    69: [
      0.06996, 0.07416, 0.0786, 0.08328, 0.08832, 0.117, 0.12405, 0.1278,
      0.13155, 0.13545, 0.1674, 0.1692, 0.17082, 0.17262, 0.17424, 0.17604,
    ],
    70: [
      0.07056, 0.07488, 0.07932, 0.08412, 0.08916, 0.11805, 0.12525, 0.129,
      0.1329, 0.1368, 0.16902, 0.17082, 0.17244, 0.17424, 0.17604, 0.17766,
    ],
    71: [
      0.07152, 0.07584, 0.0804, 0.0852, 0.09024, 0.1197, 0.12675, 0.13065,
      0.13455, 0.1386, 0.17118, 0.17298, 0.17478, 0.1764, 0.1782, 0.18,
    ],
    72: [
      0.07236, 0.0768, 0.08136, 0.08628, 0.09144, 0.1212, 0.1284, 0.1323,
      0.1362, 0.14025, 0.17334, 0.17514, 0.17694, 0.17874, 0.18054, 0.18234,
    ],
    73: [
      0.07332, 0.07776, 0.08244, 0.08736, 0.09252, 0.1227, 0.13005, 0.13395,
      0.13785, 0.14205, 0.1755, 0.1773, 0.1791, 0.1809, 0.1827, 0.1845,
    ],
    74: [
      0.07428, 0.07872, 0.0834, 0.08844, 0.09372, 0.1242, 0.13155, 0.1356,
      0.13965, 0.14385, 0.17784, 0.17946, 0.18126, 0.18306, 0.18504, 0.18684,
    ],
    75: [
      0.07512, 0.07968, 0.08436, 0.08952, 0.0948, 0.1257, 0.1332, 0.13725,
      0.1413, 0.1455, 0.18, 0.1818, 0.1836, 0.1854, 0.1872, 0.189,
    ],
    76: [
      0.07572, 0.08028, 0.08508, 0.09012, 0.09552, 0.1266, 0.13425, 0.1383,
      0.14235, 0.1467, 0.18126, 0.18306, 0.18486, 0.18684, 0.18864, 0.19044,
    ],
    77: [
      0.0762, 0.08088, 0.08568, 0.09084, 0.09624, 0.1275, 0.13515, 0.1392,
      0.1434, 0.14775, 0.1827, 0.1845, 0.1863, 0.1881, 0.19008, 0.19188,
    ],
    78: [
      0.0768, 0.08148, 0.08628, 0.09144, 0.09696, 0.12855, 0.1362, 0.14025,
      0.14445, 0.1488, 0.18396, 0.18576, 0.18774, 0.18954, 0.19152, 0.19332,
    ],
    79: [
      0.0774, 0.08208, 0.087, 0.09216, 0.09768, 0.12945, 0.13725, 0.1413,
      0.1455, 0.15, 0.1854, 0.1872, 0.189, 0.19098, 0.19278, 0.19476,
    ],
  },
  fngSafeIncomeAdvantage: {
    50: [
      0.0425, 0.046632, 0.0518281984, 0.056052598784, 0.0612769473757184,
      0.0673877381278073, 0.0740608230530013, 0.0806947302195849,
      0.0866791555349018, 0.0947896735409282, 0.103618761397529,
      0.114516969849661, 0.126217037598504, 0.138020633844577,
      0.151134322404064, 0.165137142355841, 0.18098122831658, 0.198576862090794,
      0.218117607889443, 0.239817513494854, 0.261503012152626,
    ],
    51: [
      0.0433, 0.0475968, 0.052862464, 0.0576541016064, 0.0639181951074304,
      0.0686618760335852, 0.0755784628696611, 0.0823216401030442,
      0.089818440846025, 0.0981549873944522, 0.106825531576176,
      0.117739773879201, 0.128750591272926, 0.140983509705283,
      0.154045841749851, 0.168825772683377, 0.185239610159323,
      0.203467917807316, 0.223710367066095, 0.243939377008047,
      0.266725038508977,
    ],
    52: [
      0.0443, 0.0485616, 0.054011648, 0.0602411446272, 0.0662953180659712,
      0.07177643535882, 0.077703158612985, 0.085412768881617,
      0.0933065356361619, 0.101520301247976, 0.109831878618658,
      0.120103163500864, 0.13151446800866, 0.143699479244264, 0.157486728249418,
      0.172798143805338, 0.18980216213369, 0.208685043904939, 0.227555389000044,
      0.248810670250911, 0.272348759200431,
    ],
    53: [
      0.0453, 0.0502768, 0.0560801792, 0.0615962624, 0.0674838795452416,
      0.0731921441430176, 0.0805866742646387, 0.0885038976601899,
      0.0964458209472851, 0.104324729459246, 0.112036533116478,
      0.122681406724496, 0.134048021683082, 0.146909261426696,
      0.161192298325875, 0.177054255721726, 0.194668884239682,
      0.212271818097056, 0.232099505831074, 0.254056678358611,
      0.277169091221678,
    ],
    54: [
      0.0465, 0.052528, 0.0575741184, 0.062828187648, 0.0689365657976832,
      0.0754572781977338, 0.0830148979712945, 0.0914323354504167,
      0.098887487300381, 0.106381310147511, 0.114441610750463,
      0.125044796346159, 0.137042221480127, 0.150365949930854,
      0.165162551979222, 0.181594108432539, 0.198014755687552,
      0.216510733051375, 0.236993170110644, 0.258553256736639, 0.28158772890782,
    ],
    55: [
      0.0482, 0.0536, 0.0587233024, 0.0643064979456, 0.071313688756224,
      0.0775808413740303, 0.0858984136229482, 0.0938727002756058,
      0.100805939434956, 0.108437890835776, 0.116646265248283, 0.12783789317176,
      0.140266744338483, 0.154069544756737, 0.169397489209458,
      0.184715257171224, 0.20196896739867, 0.221075718386795, 0.241187739493134,
      0.262675120249832, 0.286408060929067,
    ],
    56: [
      0.05, 0.0547792, 0.0607918336, 0.0666471559168, 0.0736908117147648,
      0.080129117185586, 0.088023109366272, 0.095824992135757,
      0.103073201048545, 0.110868395285543, 0.119251766018433,
      0.130845843599331, 0.14372159025815, 0.158020045904346, 0.172309008555246,
      0.18840388749876, 0.206227349241413, 0.224988562960013, 0.245032761427082,
      0.267171698627861, 0.291630087285417,
    ],
    57: [
      0.0511, 0.0560656, 0.0630902016, 0.0687414288384, 0.0758038099001344,
      0.0839515309029196, 0.0902995690912618, 0.0981026659726002,
      0.105514867401641, 0.113485861616062, 0.122057689924749,
      0.134068647628871, 0.147406759239128, 0.160736015443327,
      0.175749895054813, 0.192376258620721, 0.209877390820908,
      0.228575337152129, 0.249227330809572, 0.272042991870725,
      0.298458890982183,
    ],
    58: [
      0.0529, 0.0585312, 0.065503488, 0.0716980494336, 0.0797656814977024,
      0.0859335232007963, 0.0924242648345856, 0.100543030797789,
      0.108130938494244, 0.116290289827332, 0.125064036967231,
      0.137506305260381, 0.149940312913551, 0.163945797625759, 0.17945546513127,
      0.195781148153832, 0.213223262268777, 0.232488181725347,
      0.253771447640602, 0.278413144572932, 0.304082611673638,
    ],
    59: [
      0.055, 0.0612112, 0.067801856, 0.075147440128, 0.0824069292294144,
      0.088481799012352, 0.0953077804862393, 0.10249532265794,
      0.110747009586846, 0.119281679919353, 0.128270807145878,
      0.139869694882044, 0.152934512710596, 0.167402486129916,
      0.182631668053947, 0.198902296892516, 0.216873303848271,
      0.236727096679666, 0.259713754265795, 0.283659152680632,
      0.309304638029988,
    ],
    60: [
      0.058, 0.06432, 0.0707897344, 0.0774880980992, 0.0833313659355136,
      0.0894727951612904, 0.0971289482662312, 0.104772996494784,
      0.112665461721422, 0.121338260607618, 0.130475461643697,
      0.142662791707645, 0.156159035568952, 0.170365361990623,
      0.185543187399735, 0.202307186425626, 0.22082751555939, 0.242270293158391,
      0.264607418545366, 0.288530445923496, 0.315330053056546,
    ],
    61: [
      0.06, 0.0660352, 0.0727433472, 0.078227253248, 0.0842558026416128,
      0.0913132165807473, 0.098950116046223, 0.106887979343281,
      0.114932723335011, 0.123581803176634, 0.133080962413848,
      0.145670742135216, 0.158922912304685, 0.173081331529603,
      0.188719390322412, 0.205995816753162, 0.225998407797006,
      0.246835278493811, 0.269151535376396, 0.294151168896032,
      0.324569022763935,
    ],
    62: [
      0.0611, 0.0676432, 0.073547776, 0.0793359859712, 0.0863688008269824,
      0.0940030632707228, 0.101074811789547, 0.109002962191778,
      0.117374389688106, 0.126199269507153, 0.135886886320164,
      0.148248985358848, 0.161456465979108, 0.17604420739031, 0.192160276821979,
      0.210819410258401, 0.230256789639749, 0.25107419344813, 0.274394747104507,
      0.302769610787253, 0.332201215130909,
    ],
    63: [
      0.063, 0.0687152, 0.074122368, 0.0810606813184, 0.0886138613989376,
      0.0957019138117599, 0.103047743551205, 0.110792563063583,
      0.119292841822682, 0.128442812076169, 0.138291963954149,
      0.150612374980511, 0.164220342714841, 0.179253989572742,
      0.196659897629106, 0.214791781380363, 0.234211001350868,
      0.255965249164652, 0.282434338420945, 0.309889193219132, 0.33541476981174,
    ],
    64: [
      0.0635, 0.0693584, 0.0763058176, 0.0836477243392, 0.090462734811136,
      0.0972591934743774, 0.10471714734953, 0.112744854923735,
      0.121211293957257, 0.130499392764434, 0.140496618451969,
      0.153190618204143, 0.167214542511886, 0.183451397042076,
      0.200365467705563, 0.218480411707899, 0.238773553325235,
      0.263464867929986, 0.28907573994322, 0.312886912137817, 0.338628324492571,
    ],
    65: [
      0.0646, 0.0709664, 0.0780295936, 0.0848796495872, 0.0912551091306496,
      0.098108618744896, 0.105627731239526, 0.114209073818848,
      0.122955341352326, 0.132369011571947, 0.142901696085954,
      0.155983715029745, 0.171130034554176, 0.186908085546234, 0.20380635420513,
      0.222736523624287, 0.245769466352599, 0.269660205170914,
      0.291872119531546, 0.315884631056503, 0.34264526784361,
    ],
    66: [
      0.0661, 0.0730032, 0.0797533696, 0.0861115748352, 0.0925757329965056,
      0.0996658984075134, 0.107297135037852, 0.116324056667345,
      0.125222602965915, 0.135173439783217, 0.145507196856105,
      0.159636226263223, 0.174354557412531, 0.190117867728666,
      0.207776607858476, 0.229262561896081, 0.251548698853464,
      0.272268768219726, 0.294668499119872, 0.31963177970486, 0.344252045184025,
    ],
    67: [
      0.0677, 0.0743968, 0.08044288, 0.0866043449344, 0.0936322320891904,
      0.100940036313291, 0.10927006679951, 0.118601730504188, 0.127838674058517,
      0.137790906113736, 0.148914390170917, 0.162644176690794,
      0.177348757209576, 0.193821462554549, 0.213864330126941,
      0.234653636990172, 0.253982059906461, 0.274877331268537, 0.29816397360528,
      0.321130639164203, 0.345858822524441,
    ],
    68: [
      0.0692, 0.0752544, 0.0811323904, 0.088082655232, 0.0953490431148032,
      0.102638886854328, 0.111850054487832, 0.12055402236434, 0.129931530932599,
      0.140408372444255, 0.151720314077233, 0.165437273516396,
      0.180803603129243, 0.199500307954236, 0.218893318087847,
      0.236923563345579, 0.256415420959457, 0.278138035079552,
      0.299562163399443, 0.322629498623546, 0.347465599864857,
    ],
    69: [
      0.0698, 0.0758976, 0.0826263296, 0.0898073505792, 0.097065854140416,
      0.105187162665884, 0.113367694304492, 0.122506314224491,
      0.132373197285695, 0.143025838774773, 0.154325814847384,
      0.168660077545936, 0.186101033539399, 0.204191528067021,
      0.221010786702965, 0.239193489700986, 0.259457122275702,
      0.279442316603958, 0.300960353193606, 0.324128358082889,
      0.349072377205272,
    ],
    70: [
      0.0706, 0.077184, 0.0841202688, 0.0912856608768, 0.0987826651660289,
      0.106744442328501, 0.115492390047816, 0.124783988061334,
      0.134814863638791, 0.145456343224541, 0.157332161889866,
      0.173601710391231, 0.190477171704311, 0.206166778640826,
      0.223128255318084, 0.242030897645244, 0.2606738028022, 0.280746598128364,
      0.302358542987769, 0.325627217542231, 0.350277460210584,
    ],
    71: [
      0.0715, 0.0779344, 0.0853843712, 0.0932567412736, 0.101555975284326,
      0.109859001653736, 0.119134725607799, 0.128688571781636,
      0.138826172647448, 0.150130390243324, 0.161941894021671,
      0.177683928828648, 0.1923197561948, 0.20814202921463, 0.225775091086981,
      0.243165860822947, 0.261890483328698, 0.28205087965277, 0.303756732781932,
      0.326751362136739, 0.351884237550999,
    ],
    72: [
      0.0721, 0.0794352, 0.0871081472, 0.0952278216704, 0.10353691108311,
      0.112407277465292, 0.121866477277787, 0.131454318583517,
      0.142139862698078, 0.153308742216097, 0.165749933608814,
      0.179402757644403, 0.194162340685289, 0.210611092431886, 0.22683382539454,
      0.244300824000651, 0.263107163855196, 0.283355161177176,
      0.304805375127555, 0.328250221596081, 0.356302875237142,
    ],
    73: [
      0.0726, 0.0800784, 0.087912576, 0.0959669768192, 0.104725472562381,
      0.11368141537107, 0.123080589131115, 0.133081228466977, 0.143535100614133,
      0.15517836102361, 0.167353318698137, 0.181121586460158, 0.196465571298401,
      0.211598717718788, 0.2278925597021, 0.245435787178354, 0.264323844381694,
      0.28433337232048, 0.306203564921718, 0.332372085109274, 0.361123207258388,
    ],
    74: [
      0.0732, 0.0808288, 0.0886020864, 0.0970757095424, 0.105914034041651,
      0.114813982398428, 0.124446464966109, 0.134220065385398,
      0.145279148009202, 0.156674056069621, 0.168956703787461,
      0.183270122479851, 0.197386863543645, 0.21258634300569, 0.228951294009659,
      0.246570750356058, 0.265236354776567, 0.285637653844886,
      0.310048586855666, 0.336868663487303, 0.365541844944531,
    ],
    75: [
      0.0739, 0.0815792, 0.089636352, 0.0983076347904, 0.106970533134336,
      0.116088120304206, 0.125660576819437, 0.135846975268858,
      0.146674385925256, 0.158169751115632, 0.170960935149115,
      0.184129536887729, 0.19830815578889, 0.213573968292592, 0.230010028317218,
      0.247421972739335, 0.266453035303065, 0.289224428037002,
      0.314243156238155, 0.340990527000496, 0.368755399625362,
    ],
    76: [
      0.0746, 0.082544, 0.0906706176, 0.099169982464, 0.108159094613606,
      0.117220687331564, 0.127178216636096, 0.137148503175625,
      0.148069623841311, 0.160039369923145, 0.171762627693777,
      0.184988951295606, 0.199229448034134, 0.214561593579494,
      0.230804079047887, 0.248556935917038, 0.269798906750935, 0.29313727261022,
      0.318088178172104, 0.343988245919181, 0.368755399625362,
    ],
    77: [
      0.0754, 0.0835088, 0.0915899648, 0.100401907712, 0.109215593706291,
      0.118636396115762, 0.128392328489424, 0.138450031082393, 0.14981367123638,
      0.16078721744615, 0.172564320238439, 0.185848365703483, 0.200150740279379,
      0.215302312544671, 0.231862813355446, 0.251678084655723,
      0.273448948330429, 0.296724046802336, 0.32088455776043, 0.343988245919181,
      0.368755399625362,
    ],
    78: [
      0.0763, 0.0842592, 0.0927391488, 0.1013874479104, 0.110536217572147,
      0.11976896314312, 0.129606440342752, 0.140239631954198, 0.150511290194407,
      0.161535064969156, 0.1733660127831, 0.186707780111361, 0.200841709463312,
      0.216289937831573, 0.234774332701234, 0.255082974188833,
      0.276794819778298, 0.299332609851148, 0.32088455776043, 0.343988245919181,
      0.368755399625362,
    ],
    79: [
      0.0771, 0.0853312, 0.093658496, 0.1026193731584, 0.111592716664832,
      0.120901530170478, 0.131275844141078, 0.140890395907582,
      0.151208909152434, 0.162282912492161, 0.174167705327762,
      0.187352340917269, 0.201763001708557, 0.219005907370554,
      0.237950535623911, 0.258204122927517, 0.279228180831294,
      0.299332609851148, 0.32088455776043, 0.343988245919181, 0.368755399625362,
    ],
    80: [
      0.078, 0.0861888, 0.0946927616, 0.1036049133568, 0.112649215757517,
      0.122458809833095, 0.131731136086076, 0.141378468872619,
      0.151732123370955, 0.162843798134415, 0.174768974736258,
      0.188211755325146, 0, 0.22196878323126, 0, 0.260474049282924, 0,
      0.299332609851148, 0, 0.343988245919181, 0,
    ],
  },
  // updated 9-28-25- Athene Single Level
  singleLevel: {
    50: [
      0.0588, 0.06435, 0.07, 0.0765, 0.0832, 0.09095, 0.0972, 0.10355, 0.112,
      0.11865, 0.1287, 0.13662, 0.14472, 0.153, 0.16146, 0.1701, 0.17948,
      0.18908, 0.1989, 0.20894, 0.2192, 0.285929241281623, 0.312978836492988,
      0.3414516014412, 0.371871475127857, 0.405470407722291,
    ],
    51: [
      0.0606, 0.0663, 0.0721, 0.078, 0.0848, 0.0918, 0.0981, 0.1045, 0.113,
      0.12075, 0.132, 0.13984, 0.14784, 0.156, 0.16432, 0.1728, 0.18228,
      0.19198, 0.2019, 0.21204, 0.2224, 0.291957869862862, 0.318518284926492,
      0.346895032768523, 0.378237320636465, 0.412863276306287,
    ],
    52: [
      0.0612, 0.06695, 0.0728, 0.07875, 0.0856, 0.09265, 0.099, 0.10545, 0.114,
      0.12285, 0.1331, 0.14122, 0.14952, 0.158, 0.16666, 0.1755, 0.18508,
      0.19488, 0.2049, 0.21514, 0.2256, 0.297125265789638, 0.323596112657204,
      0.35283332148924, 0.38513365327079, 0.42253087368536,
    ],
    53: [
      0.0618, 0.0676, 0.0735, 0.08025, 0.0872, 0.09435, 0.1008, 0.10735, 0.116,
      0.12495, 0.1353, 0.14352, 0.15192, 0.1605, 0.16926, 0.1782, 0.18816,
      0.19836, 0.2088, 0.21948, 0.2304, 0.301862045389183, 0.329135561090709,
      0.359266467603349, 0.394151934407985, 0.430492424468126,
    ],
    54: [
      0.0624, 0.06825, 0.0749, 0.08175, 0.0888, 0.09605, 0.1026, 0.10925, 0.118,
      0.12705, 0.1386, 0.14697, 0.15552, 0.16425, 0.17316, 0.18225, 0.19208,
      0.20213, 0.2124, 0.22289, 0.2336, 0.30702944131596, 0.335136630227005,
      0.367679043291031, 0.401578754168028, 0.437885293052123,
    ],
    55: [
      0.063, 0.0689, 0.0756, 0.0825, 0.0896, 0.0969, 0.1035, 0.1102, 0.119,
      0.12915, 0.1419, 0.15019, 0.15864, 0.16725, 0.17602, 0.18495, 0.19516,
      0.20561, 0.2163, 0.22723, 0.2384, 0.312627453569967, 0.342984182174469,
      0.374607046798534, 0.408475086802353, 0.446415526033658,
    ],
    56: [
      0.0636, 0.06955, 0.0763, 0.08325, 0.0904, 0.09775, 0.1044, 0.11115, 0.121,
      0.1302, 0.1441, 0.15249, 0.16104, 0.16975, 0.17862, 0.18765, 0.19796,
      0.20851, 0.2193, 0.23033, 0.2416, 0.3199479311329, 0.349446872013557,
      0.381040192912643, 0.416432393688114, 0.459495216605345,
    ],
    57: [
      0.0648, 0.07085, 0.0777, 0.084, 0.0912, 0.0986, 0.1053, 0.1121, 0.123,
      0.13335, 0.1463, 0.15479, 0.16344, 0.17225, 0.18122, 0.19035, 0.20104,
      0.21199, 0.2232, 0.23467, 0.2464, 0.325976559714139, 0.355447941149854,
      0.388463053813539, 0.428633597579612, 0.470300178381955,
    ],
    58: [
      0.066, 0.07215, 0.0791, 0.08625, 0.0936, 0.10115, 0.108, 0.11495, 0.125,
      0.13545, 0.1485, 0.15732, 0.16632, 0.1755, 0.18486, 0.1944, 0.20496,
      0.21576, 0.2268, 0.23808, 0.2496, 0.331574571968147, 0.362372251691734,
      0.399844773861579, 0.438712852968242, 0.474849635972107,
    ],
    59: [
      0.0672, 0.07345, 0.0798, 0.087, 0.0952, 0.1037, 0.1107, 0.1178, 0.127,
      0.1386, 0.1507, 0.15962, 0.16872, 0.178, 0.18746, 0.1971, 0.20832,
      0.21982, 0.2316, 0.24366, 0.256, 0.338033816876617, 0.37298952785595,
      0.409247064336047, 0.442956749973981, 0.479399093562259,
    ],
    60: [
      0.0678, 0.0741, 0.0805, 0.08775, 0.096, 0.10455, 0.1116, 0.11875, 0.13,
      0.1407, 0.1529, 0.16215, 0.1716, 0.18125, 0.1911, 0.20115, 0.2128,
      0.22475, 0.237, 0.24955, 0.2624, 0.347937992402939, 0.381760321208999,
      0.413205923483191, 0.447200646979719, 0.485085915549949,
    ],
    61: [
      0.0684, 0.07475, 0.0812, 0.08925, 0.0976, 0.10625, 0.1134, 0.12065, 0.133,
      0.1428, 0.1562, 0.16537, 0.17472, 0.18425, 0.19396, 0.20385, 0.21616,
      0.22881, 0.2418, 0.25513, 0.2688, 0.356119702620335, 0.385453286831335,
      0.417164782630335, 0.452505518236893, 0.487360644345025,
    ],
    62: [
      0.069, 0.0754, 0.0826, 0.09075, 0.0992, 0.10965, 0.117, 0.12445, 0.134,
      0.14595, 0.1584, 0.1679, 0.1776, 0.1875, 0.1976, 0.2079, 0.22092, 0.23432,
      0.2481, 0.26226, 0.2768, 0.359564633238185, 0.389146252453671,
      0.422113356564266, 0.454627466739762, 0.489635373140101,
    ],
    63: [
      0.0696, 0.07605, 0.084, 0.09225, 0.1008, 0.11135, 0.1188, 0.12635, 0.137,
      0.14805, 0.1606, 0.1702, 0.18, 0.19, 0.2002, 0.2106, 0.22484, 0.23954,
      0.2547, 0.27032, 0.2864, 0.363009563856036, 0.393762459481591,
      0.424092786137838, 0.456749415242632, 0.491910101935177,
    ],
    64: [
      0.0708, 0.07735, 0.0854, 0.09375, 0.1032, 0.11305, 0.1206, 0.12825, 0.139,
      0.15015, 0.1639, 0.17388, 0.18408, 0.1945, 0.20514, 0.216, 0.231, 0.2465,
      0.2625, 0.279, 0.296, 0.36731572712835, 0.395608942292759,
      0.42607221571141, 0.458871363745501, 0.494184830730253,
    ],
    65: [
      0.0726, 0.0793, 0.0868, 0.09525, 0.104, 0.11475, 0.1224, 0.13015, 0.141,
      0.1533, 0.1672, 0.17756, 0.18816, 0.199, 0.21008, 0.2214, 0.23716,
      0.25346, 0.2703, 0.28768, 0.3056, 0.369038192437275, 0.397455425103927,
      0.428051645284982, 0.46099331224837, 0.49589087732656,
    ],
    66: [
      0.0732, 0.07995, 0.0875, 0.096, 0.1048, 0.1156, 0.1233, 0.1311, 0.143,
      0.15435, 0.1683, 0.1794, 0.1908, 0.2025, 0.2145, 0.2268, 0.24332, 0.26042,
      0.2781, 0.29636, 0.3152, 0.370760657746201, 0.399301907915095,
      0.430031074858554, 0.462584773625522, 0.498165606121636,
    ],
    67: [
      0.0738, 0.0806, 0.0896, 0.09825, 0.1072, 0.1173, 0.1251, 0.133, 0.145,
      0.15645, 0.1694, 0.18147, 0.19392, 0.20675, 0.21996, 0.23355, 0.25032,
      0.26767, 0.2856, 0.30411, 0.3232, 0.372483123055126, 0.401148390726263,
      0.431515647038734, 0.464706722128392, 0.504421110308095,
    ],
    68: [
      0.0744, 0.08125, 0.0903, 0.09975, 0.1096, 0.119, 0.1269, 0.1349, 0.147,
      0.15855, 0.1716, 0.18469, 0.19824, 0.21225, 0.22672, 0.24165, 0.25872,
      0.27637, 0.2946, 0.31341, 0.3328, 0.374205588364052, 0.40253325283464,
      0.433495076612306, 0.470542080511283, 0.511245296693323,
    ],
    69: [
      0.075, 0.0819, 0.091, 0.1005, 0.1104, 0.1207, 0.1287, 0.1368, 0.149,
      0.16065, 0.1727, 0.18653, 0.20088, 0.21575, 0.23114, 0.24705, 0.2646,
      0.28275, 0.3015, 0.32085, 0.3408, 0.375497437345746, 0.404379735645808,
      0.438938507939629, 0.476907926019891, 0.517500800879782,
    ],
    70: [
      0.0756, 0.08255, 0.0917, 0.10125, 0.1112, 0.12155, 0.1296, 0.13775, 0.151,
      0.16275, 0.176, 0.1909, 0.2064, 0.2225, 0.2392, 0.2565, 0.27412, 0.29232,
      0.3111, 0.33046, 0.3504, 0.377219902654671, 0.40945756337652,
      0.444876796660346, 0.482743284402781, 0.522050258469934,
    ],
    71: [
      0.0768, 0.08385, 0.0931, 0.10275, 0.1128, 0.12495, 0.1332, 0.14155, 0.153,
      0.16485, 0.1793, 0.19527, 0.21192, 0.22925, 0.24726, 0.26595, 0.28196,
      0.29841, 0.3153, 0.33263, 0.3504, 0.381956682254216, 0.414997011810024,
      0.450320227987669, 0.48698718140852, 0.522050258469934,
    ],
    72: [
      0.078, 0.08515, 0.0945, 0.10425, 0.1144, 0.12665, 0.135, 0.14345, 0.155,
      0.168, 0.1826, 0.19918, 0.21648, 0.2345, 0.25324, 0.2727, 0.28756,
      0.30276, 0.3183, 0.33418, 0.3504, 0.387124078180993, 0.420074839540736,
      0.454279087134813, 0.48698718140852, 0.522050258469934,
    ],
    73: [
      0.0786, 0.0871, 0.0966, 0.1065, 0.1168, 0.1275, 0.1368, 0.1501, 0.165,
      0.1743, 0.1903, 0.207, 0.2244, 0.2425, 0.2613, 0.2808, 0.29428, 0.30798,
      0.3219, 0.33604, 0.3504, 0.391860857780537, 0.423767805163072,
      0.454279087134813, 0.48698718140852, 0.522050258469934,
    ],
    74: [
      0.0792, 0.08775, 0.0973, 0.10725, 0.1176, 0.12835, 0.1413, 0.1558, 0.172,
      0.18165, 0.1969, 0.21367, 0.23112, 0.24925, 0.26806, 0.28755, 0.29988,
      0.31233, 0.3249, 0.33759, 0.3504, 0.395305788398388, 0.423767805163072,
      0.454279087134813, 0.48698718140852, 0.522050258469934,
    ],
    75: [
      0.0798, 0.0884, 0.098, 0.108, 0.1184, 0.13175, 0.1458, 0.16055, 0.178,
      0.18795, 0.2046, 0.22149, 0.23904, 0.25725, 0.27612, 0.29565, 0.3066,
      0.31755, 0.3285, 0.33945, 0.3504, 0.395305788398388, 0.423767805163072,
      0.454279087134813, 0.48698718140852, 0.522050258469934,
    ],
    76: [
      0.0804, 0.08905, 0.0987, 0.10875, 0.1192, 0.1326, 0.1467, 0.1615, 0.179,
      0.1953, 0.2123, 0.22793, 0.24408, 0.26075, 0.27794, 0.29565,
      0.269798906750935, 0.29313727261022, 0.318088178172104, 0.343988245919181,
      0.368755399625362, 0.395305788398388, 0.423767805163072,
      0.454279087134813, 0.48698718140852, 0,
    ],
    77: [
      0.081, 0.0897, 0.0994, 0.1095, 0.12, 0.1343, 0.1494, 0.16625, 0.185,
      0.20265, 0.2189, 0.23345, 0.2484, 0.26375, 0.2795, 0.29565,
      0.273448948330429, 0.296724046802336, 0.32088455776043, 0.343988245919181,
      0.368755399625362, 0.395305788398388, 0.423767805163072,
      0.454279087134813, 0, 0,
    ],
    78: [
      0.0816, 0.09035, 0.1008, 0.11175, 0.1248, 0.1394, 0.1548, 0.171, 0.192,
      0.2079, 0.2255, 0.23897, 0.25272, 0.26675, 0.28106, 0.29565,
      0.276794819778298, 0.299332609851148, 0.32088455776043, 0.343988245919181,
      0.368755399625362, 0.395305788398388, 0.423767805163072, 0, 0, 0,
    ],
    79: [
      0.0828, 0.09295, 0.1036, 0.11625, 0.128, 0.14365, 0.1602, 0.1786, 0.197,
      0.2142, 0.231, 0.24357, 0.25632, 0.26925, 0.28236, 0.29565,
      0.279228180831294, 0.299332609851148, 0.32088455776043, 0.343988245919181,
      0.368755399625362, 0.395305788398388, 0, 0, 0, 0,
    ],
    80: [
      0.0852, 0.09555, 0.1078, 0.11925, 0.1336, 0.1496, 0.1674, 0.18335, 0.203,
      0.21945, 0.2376, 0.24909, 0.26064, 0.27225, 0.28392, 0.29565, 0,
      0.299332609851148, 0, 0.343988245919181, 0, 0, 0, 0, 0, 0,
    ],
  },
  // updated 9-28-25 Athene Joint Level
  jointLevel: {
    50: [
      0.0528, 0.05785, 0.063, 0.069, 0.0752, 0.08245, 0.0882, 0.09405, 0.102,
      0.10815, 0.1177, 0.12512, 0.13272, 0.1405, 0.14846, 0.1566, 0.16548,
      0.17458, 0.1839, 0.19344, 0.2032, 0.197652894199194, 0.211883902581536,
      0.332049310966732, 0.360731245487793, 0.389547306156759,
    ],
    51: [
      0.0546, 0.0598, 0.0651, 0.0705, 0.0768, 0.0833, 0.0891, 0.095, 0.103,
      0.11025, 0.121, 0.12834, 0.13584, 0.1435, 0.15132, 0.1593, 0.16828,
      0.17748, 0.1869, 0.19654, 0.2064, 0.197652894199194, 0.211883902581536,
      0.336503027507269, 0.363383681116379, 0.392959399349373,
    ],
    52: [
      0.0552, 0.06045, 0.0658, 0.07125, 0.0776, 0.08415, 0.09, 0.09595, 0.104,
      0.11235, 0.1221, 0.12972, 0.13752, 0.1455, 0.15366, 0.162, 0.17108,
      0.18038, 0.1899, 0.19964, 0.2096, 0.197652894199194, 0.211883902581536,
      0.338977314474235, 0.366566603870683, 0.393528081548142,
    ],
    53: [
      0.0558, 0.0611, 0.0665, 0.07275, 0.0792, 0.08585, 0.0918, 0.09785, 0.106,
      0.11445, 0.1243, 0.13202, 0.13992, 0.148, 0.15626, 0.1647, 0.17416,
      0.18386, 0.1938, 0.20398, 0.2144, 0.197652894199194, 0.211883902581536,
      0.341946458834593, 0.367097090996401, 0.395234128144449,
    ],
    54: [
      0.0564, 0.06175, 0.0679, 0.07425, 0.0808, 0.08755, 0.0936, 0.09975, 0.108,
      0.11655, 0.1276, 0.13547, 0.14352, 0.15175, 0.16016, 0.16875, 0.17808,
      0.18763, 0.1974, 0.20739, 0.2176, 0.197652894199194, 0.211883902581536,
      0.342441316227986, 0.368688552373553, 0.398077539138294,
    ],
    55: [
      0.057, 0.0624, 0.0686, 0.075, 0.0816, 0.0884, 0.0945, 0.1007, 0.109,
      0.11865, 0.1309, 0.13869, 0.14664, 0.15475, 0.16302, 0.17145, 0.18116,
      0.19111, 0.2013, 0.21173, 0.2224, 0.197652894199194, 0.211883902581536,
      0.343925888408165, 0.37134098800214, 0.401489632330908,
    ],
    56: [
      0.0576, 0.06305, 0.0693, 0.07575, 0.0824, 0.08925, 0.0954, 0.10165, 0.111,
      0.1197, 0.1331, 0.14099, 0.14904, 0.15725, 0.16562, 0.17415, 0.18396,
      0.19401, 0.2043, 0.21483, 0.2256, 0.197652894199194, 0.211883902581536,
      0.34640017537513, 0.374523910756444, 0.406607772119828,
    ],
    57: [
      0.0588, 0.06435, 0.0707, 0.0765, 0.0832, 0.0901, 0.0963, 0.1026, 0.113,
      0.12285, 0.1353, 0.14329, 0.15144, 0.15975, 0.16822, 0.17685, 0.18704,
      0.19749, 0.2082, 0.21917, 0.2304, 0.197652894199194, 0.211883902581536,
      0.349369319735488, 0.3792982948879, 0.410019865312442,
    ],
    58: [
      0.06, 0.06565, 0.0721, 0.07875, 0.0856, 0.09265, 0.099, 0.10545, 0.115,
      0.12495, 0.1375, 0.14582, 0.15432, 0.163, 0.17186, 0.1809, 0.19096,
      0.20126, 0.2118, 0.22258, 0.2336, 0.197652894199194, 0.211883902581536,
      0.353823036276026, 0.382481217642204, 0.408882500914904,
    ],
    59: [
      0.0612, 0.06695, 0.0728, 0.0795, 0.0872, 0.0952, 0.1017, 0.1083, 0.117,
      0.1281, 0.1397, 0.14812, 0.15672, 0.1655, 0.17446, 0.1836, 0.19432,
      0.20532, 0.2166, 0.22816, 0.24, 0.197652894199194, 0.211883902581536,
      0.356792180636384, 0.381420243390769, 0.407176454318598,
    ],
    60: [
      0.0618, 0.0676, 0.0735, 0.08025, 0.088, 0.09605, 0.1026, 0.10925, 0.12,
      0.1302, 0.1419, 0.15065, 0.1596, 0.16875, 0.1781, 0.18765, 0.1988,
      0.21025, 0.222, 0.23405, 0.2464, 0.197652894199194, 0.211883902581536,
      0.355802465849598, 0.379828782013617, 0.40603908992106,
    ],
    61: [
      0.0624, 0.06825, 0.0742, 0.08175, 0.0896, 0.09775, 0.1044, 0.11115, 0.123,
      0.1323, 0.1452, 0.15387, 0.16272, 0.17175, 0.18096, 0.19035, 0.20216,
      0.21431, 0.2268, 0.23963, 0.2528, 0.197652894199194, 0.211883902581536,
      0.354317893669419, 0.378767807762182, 0.404333043324753,
    ],
    62: [
      0.063, 0.0689, 0.0756, 0.08325, 0.0912, 0.10115, 0.108, 0.11495, 0.124,
      0.13545, 0.1474, 0.1564, 0.1656, 0.175, 0.1846, 0.1944, 0.20692, 0.21982,
      0.2331, 0.24676, 0.2608, 0.197652894199194, 0.211883902581536,
      0.353328178882633, 0.37717634638503, 0.402626996728446,
    ],
    63: [
      0.0636, 0.06955, 0.077, 0.08475, 0.0928, 0.10285, 0.1098, 0.11685, 0.127,
      0.13755, 0.1496, 0.1587, 0.168, 0.1775, 0.1872, 0.1971, 0.21084, 0.22504,
      0.2397, 0.25482, 0.2704, 0.197652894199194, 0.211883902581536,
      0.351843606702454, 0.375584885007878, 0.400920950132139,
    ],
    64: [
      0.0648, 0.07085, 0.0784, 0.08625, 0.0952, 0.10455, 0.1116, 0.11875, 0.129,
      0.13965, 0.1529, 0.16238, 0.17208, 0.182, 0.19214, 0.2025, 0.217, 0.232,
      0.2475, 0.2635, 0.28, 0.197652894199194, 0.211883902581536,
      0.350359034522274, 0.373993423630726, 0.399214903535832,
    ],
    65: [
      0.0666, 0.0728, 0.0798, 0.08775, 0.096, 0.10625, 0.1134, 0.12065, 0.131,
      0.1428, 0.1562, 0.16606, 0.17616, 0.1865, 0.19708, 0.2079, 0.22316,
      0.23896, 0.2553, 0.27218, 0.2896, 0.197652894199194, 0.211883902581536,
      0.348874462342095, 0.372401962253574, 0.397508856939525,
    ],
    66: [
      0.0672, 0.07345, 0.0805, 0.0885, 0.0968, 0.1071, 0.1143, 0.1216, 0.133,
      0.14385, 0.1573, 0.1679, 0.1788, 0.19, 0.2015, 0.2133, 0.22932, 0.24592,
      0.2631, 0.28086, 0.2992, 0.197652894199194, 0.211883902581536,
      0.347389890161916, 0.370810500876422, 0.398646221337063,
    ],
    67: [
      0.0678, 0.0741, 0.0826, 0.09075, 0.0992, 0.1088, 0.1161, 0.1235, 0.135,
      0.14595, 0.1584, 0.16997, 0.18192, 0.19425, 0.20696, 0.22005, 0.23632,
      0.25317, 0.2706, 0.28861, 0.3072, 0.197652894199194, 0.211883902581536,
      0.345905317981737, 0.371871475127857, 0.403764361125984,
    ],
    68: [
      0.0684, 0.07475, 0.0833, 0.09225, 0.1016, 0.1105, 0.1179, 0.1254, 0.137,
      0.14805, 0.1606, 0.17319, 0.18624, 0.19975, 0.21372, 0.22815, 0.24472,
      0.26187, 0.2796, 0.29791, 0.3168, 0.197652894199194, 0.211883902581536,
      0.346895032768523, 0.376645859259313, 0.408882500914904,
    ],
    69: [
      0.069, 0.0754, 0.084, 0.093, 0.1024, 0.1122, 0.1197, 0.1273, 0.139,
      0.15015, 0.1617, 0.17503, 0.18888, 0.20325, 0.21814, 0.23355, 0.2506,
      0.26825, 0.2865, 0.30535, 0.3248, 0.197652894199194, 0.211883902581536,
      0.351348749309061, 0.381420243390769, 0.414000640703825,
    ],
    70: [
      0.0696, 0.07605, 0.0847, 0.09375, 0.1032, 0.11305, 0.1206, 0.12825, 0.141,
      0.15225, 0.165, 0.1794, 0.1944, 0.21, 0.2262, 0.243, 0.26012, 0.27782,
      0.2961, 0.31496, 0.3344, 0.197652894199194, 0.211883902581536,
      0.355802465849598, 0.386194627522225, 0.417981416095208,
    ],
    71: [
      0.0708, 0.07735, 0.0861, 0.09525, 0.1048, 0.11645, 0.1242, 0.13205, 0.143,
      0.15435, 0.1683, 0.18377, 0.19992, 0.21675, 0.23426, 0.25245, 0.26796,
      0.28391, 0.3003, 0.31713, 0.3344, 0.197652894199194, 0.211883902581536,
      0.360256182390135, 0.389908037402246, 0.417981416095208,
    ],
    72: [
      0.072, 0.07865, 0.0875, 0.09675, 0.1064, 0.11815, 0.126, 0.13395, 0.145,
      0.1575, 0.1716, 0.18768, 0.20448, 0.222, 0.24024, 0.2592, 0.27356,
      0.28826, 0.3033, 0.31868, 0.3344, 0.197652894199194, 0.211883902581536,
      0.363720184143887, 0.389908037402246, 0.417981416095208,
    ],
    73: [
      0.0726, 0.0806, 0.0896, 0.099, 0.1088, 0.119, 0.1278, 0.1406, 0.155,
      0.1638, 0.1793, 0.1955, 0.2124, 0.23, 0.2483, 0.2673, 0.28028, 0.29348,
      0.3069, 0.32054, 0.3344, 0.197652894199194, 0.211883902581536,
      0.363720184143887, 0.389908037402246, 0.417981416095208,
    ],
    74: [
      0.0732, 0.08125, 0.0903, 0.09975, 0.1096, 0.11985, 0.1323, 0.1463, 0.162,
      0.17115, 0.1859, 0.20217, 0.21912, 0.23675, 0.25506, 0.27405, 0.28588,
      0.29783, 0.3099, 0.32209, 0.3344, 0.197652894199194, 0.211883902581536,
      0.363720184143887, 0.389908037402246, 0.417981416095208,
    ],
    75: [
      0.0738, 0.0819, 0.091, 0.1005, 0.1104, 0.12325, 0.1368, 0.15105, 0.168,
      0.17745, 0.1936, 0.20999, 0.22704, 0.24475, 0.26312, 0.28215, 0.2926,
      0.30305, 0.3135, 0.32395, 0.3344, 0.197652894199194, 0.211883902581536,
      0.363720184143887, 0.389908037402246, 0.417981416095208,
    ],
    76: [
      0.0744, 0.08255, 0.0917, 0.10125, 0.1112, 0.1241, 0.1377, 0.152, 0.169,
      0.1848, 0.2013, 0.21643, 0.23208, 0.24825, 0.26494, 0.28215,
      0.215960793453398, 0.234444604011955, 0.254470542537683,
      0.275415425654246, 0.295245336301352, 0.197652894199194,
      0.211883902581536, 0.363720184143887, 0.389908037402246, 0,
    ],
    77: [
      0.075, 0.0832, 0.0924, 0.102, 0.112, 0.1258, 0.1404, 0.15675, 0.175,
      0.19215, 0.2079, 0.22195, 0.2364, 0.25125, 0.2665, 0.28215,
      0.218698324638018, 0.237379237441869, 0.256917374677469,
      0.275415425654246, 0.295245336301352, 0.197652894199194,
      0.211883902581536, 0.363720184143887, 0, 0,
    ],
    78: [
      0.0756, 0.08385, 0.0938, 0.10425, 0.1168, 0.1309, 0.1458, 0.1615, 0.182,
      0.1974, 0.2145, 0.22747, 0.24072, 0.25425, 0.26806, 0.28215,
      0.221435855822639, 0.239661730109579, 0.256917374677469,
      0.275415425654246, 0.295245336301352, 0.197652894199194,
      0.211883902581536, 0, 0, 0,
    ],
    79: [
      0.0768, 0.08645, 0.0966, 0.10875, 0.12, 0.13515, 0.1512, 0.1691, 0.187,
      0.2037, 0.22, 0.23207, 0.24432, 0.25675, 0.26936, 0.28215,
      0.22356504674401, 0.239661730109579, 0.256917374677469, 0.275415425654246,
      0.295245336301352, 0.197652894199194, 0, 0, 0, 0,
    ],
    80: [
      0.0792, 0.08905, 0.1008, 0.11175, 0.1256, 0.1411, 0.1584, 0.17385, 0.193,
      0.20895, 0.2266, 0.23759, 0.24864, 0.25975, 0.27092, 0.28215, 0,
      0.239661730109579, 0, 0.275415425654246, 0, 0, 0, 0, 0, 0,
    ],
  },
  // updated 4-28-25
  singleInflation: {
    50: [
      0.0425, 0.046632, 0.0518281984, 0.0576541016064, 0.0612769473757184,
      0.0673877381278073, 0.0740608230530013, 0.0806947302195849,
      0.0866791555349018, 0.0947896735409282, 0.103618761397529,
      0.114516969849661, 0.126217037598504, 0.138020633844577,
      0.151134322404064, 0.165137142355841, 0.18098122831658, 0.198576862090794,
      0.218117607889443, 0.239817513494854, 0.261503012152626,
      0.285929241281623, 0.312978836492988, 0.3414516014412, 0.371871475127857,
      0.405470407722291,
    ],
    51: [
      0.0435, 0.0475968, 0.054011648, 0.0576541016064, 0.0639181951074304,
      0.0686618760335852, 0.0755784628696611, 0.0823216401030442,
      0.089818440846025, 0.0981549873944522, 0.106825531576176,
      0.117739773879201, 0.128750591272926, 0.140983509705283,
      0.154045841749851, 0.168825772683377, 0.185239610159323,
      0.203467917807316, 0.223710367066095, 0.243939377008047,
      0.266725038508977, 0.291957869862862, 0.318518284926492,
      0.346895032768523, 0.378237320636465, 0.412863276306287,
    ],
    52: [
      0.0443, 0.0502768, 0.054011648, 0.0602411446272, 0.0662953180659712,
      0.07177643535882, 0.077703158612985, 0.085412768881617,
      0.0933065356361619, 0.101520301247976, 0.109831878618658,
      0.120103163500864, 0.13151446800866, 0.143699479244264, 0.157486728249418,
      0.172798143805338, 0.18980216213369, 0.208685043904939, 0.227555389000044,
      0.248810670250911, 0.272348759200431, 0.297125265789638,
      0.323596112657204, 0.35283332148924, 0.38513365327079, 0.42253087368536,
    ],
    53: [
      0.0465, 0.0502768, 0.0560801792, 0.0615962624, 0.0674838795452416,
      0.0731921441430176, 0.0805866742646387, 0.0885038976601899,
      0.0964458209472851, 0.104324729459246, 0.112036533116478,
      0.122681406724496, 0.134048021683082, 0.146909261426696,
      0.161192298325875, 0.177054255721726, 0.194668884239682,
      0.212271818097056, 0.232099505831074, 0.254056678358611,
      0.277169091221678, 0.301862045389183, 0.329135561090709,
      0.359266467603349, 0.394151934407985, 0.430492424468126,
    ],
    54: [
      0.0465, 0.052528, 0.0575741184, 0.0629513801728, 0.0689365657976832,
      0.0754572781977338, 0.0830148979712945, 0.0914323354504167,
      0.098887487300381, 0.106381310147511, 0.114441610750463,
      0.125044796346159, 0.137042221480127, 0.150365949930854,
      0.165162551979222, 0.181594108432539, 0.198014755687552,
      0.216510733051375, 0.236993170110644, 0.258553256736639, 0.28158772890782,
      0.30702944131596, 0.335136630227005, 0.367679043291031, 0.401578754168028,
      0.437885293052123,
    ],
    55: [
      0.0482, 0.0536, 0.0587233024, 0.0643064979456, 0.071313688756224,
      0.0775808413740303, 0.0858984136229482, 0.0938727002756058,
      0.100805939434956, 0.108437890835776, 0.116646265248283, 0.12783789317176,
      0.140266744338483, 0.154069544756737, 0.169397489209458,
      0.184715257171224, 0.20196896739867, 0.221075718386795, 0.241187739493134,
      0.262675120249832, 0.286408060929067, 0.312627453569967,
      0.342984182174469, 0.374607046798534, 0.408475086802353,
      0.446415526033658,
    ],
    56: [
      0.05, 0.0547792, 0.0607918336, 0.0666471559168, 0.0736908117147648,
      0.080129117185586, 0.088023109366272, 0.095824992135757,
      0.103073201048545, 0.110868395285543, 0.119251766018433,
      0.130845843599331, 0.14372159025815, 0.158020045904346, 0.172309008555246,
      0.18840388749876, 0.206227349241413, 0.224988562960013, 0.245032761427082,
      0.267171698627861, 0.291630087285417, 0.3199479311329, 0.349446872013557,
      0.381040192912643, 0.416432393688114, 0.459495216605345,
    ],
    57: [
      0.0511, 0.0560656, 0.0633200384, 0.0687414288384, 0.0758038099001344,
      0.0870660902281544, 0.0936383766879135, 0.100705721786135,
      0.108130938494244, 0.116290289827332, 0.125064036967231,
      0.134068647628871, 0.147406759239128, 0.160736015443327,
      0.175749895054813, 0.192376258620721, 0.209877390820908,
      0.228575337152129, 0.249227330809572, 0.272042991870725,
      0.298458890982183, 0.325976559714139, 0.355447941149854,
      0.388463053813539, 0.428633597579612, 0.470300178381955,
    ],
    58: [
      0.0529, 0.0587456, 0.065503488, 0.0716980494336, 0.081878679683072,
      0.0890480825260311, 0.0957630724312373, 0.102820704634632,
      0.11057260484734, 0.118907756157851, 0.127869960873547, 0.137506305260381,
      0.149940312913551, 0.163945797625759, 0.17945546513127, 0.195781148153832,
      0.213223262268777, 0.232488181725347, 0.253771447640602,
      0.278413144572932, 0.304082611673638, 0.331574571968147,
      0.362372251691734, 0.399844773861579, 0.438712852968242,
      0.474849635972107,
    ],
    59: [
      0.055, 0.0614256, 0.067801856, 0.0767489429504, 0.0837275530952704,
      0.0910300748239078, 0.0977360041928951, 0.105098378471475,
      0.113014271200435, 0.121712184369121, 0.130876307916028,
      0.139869694882044, 0.152934512710596, 0.167402486129916,
      0.182631668053947, 0.198902296892516, 0.216873303848271,
      0.236727096679666, 0.259713754265795, 0.283659152680632,
      0.309304638029988, 0.338033816876617, 0.37298952785595, 0.409247064336047,
      0.442956749973981, 0.479399093562259,
    ],
    60: [
      0.058, 0.06432, 0.0715941632, 0.0784736382976, 0.0855764265074688,
      0.0934367797570438, 0.100467755862883, 0.108026816261702,
      0.116153556511559, 0.124890536341894, 0.134483924367006,
      0.142662791707645, 0.156159035568952, 0.170365361990623,
      0.185543187399735, 0.202307186425626, 0.22082751555939, 0.242270293158391,
      0.264607418545366, 0.288530445923496, 0.315330053056546,
      0.347937992402939, 0.381760321208999, 0.413205923483191,
      0.447200646979719, 0.485085915549949,
    ],
    61: [
      0.06, 0.0663568, 0.0732030208, 0.08007514112, 0.0876894246928384,
      0.0944277759059821, 0.101530103734545, 0.109165653180124,
      0.117548794427613, 0.126386231387904, 0.13608730945633, 0.145670742135216,
      0.158922912304685, 0.173081331529603, 0.188719390322412,
      0.205995816753162, 0.225998407797006, 0.246835278493811,
      0.269151535376396, 0.294151168896032, 0.324569022763935,
      0.356119702620335, 0.385453286831335, 0.417164782630335,
      0.452505518236893, 0.487360644345025,
    ],
    62: [
      0.0611, 0.0677504, 0.07469696, 0.081923028992, 0.0887459237855232,
      0.0958434846901797, 0.103047743551205, 0.110792563063583,
      0.119292841822682, 0.128442812076169, 0.138091540817984,
      0.148248985358848, 0.161456465979108, 0.17604420739031, 0.192160276821979,
      0.210819410258401, 0.230256789639749, 0.25107419344813, 0.274394747104507,
      0.302769610787253, 0.332201215130909, 0.359564633238185,
      0.389146252453671, 0.422113356564266, 0.454627466739762,
      0.489635373140101,
    ],
    63: [
      0.063, 0.0693584, 0.0763058176, 0.08315495424, 0.0900665476513792,
      0.0972591934743773, 0.104565383367865, 0.112582163935389,
      0.12103688921775, 0.130312430883682, 0.140296195315804, 0.150612374980511,
      0.164220342714841, 0.179253989572742, 0.196659897629106,
      0.214791781380363, 0.234211001350868, 0.255965249164652,
      0.282434338420945, 0.309889193219132, 0.33541476981174, 0.363009563856036,
      0.393762459481591, 0.424092786137838, 0.456749415242632,
      0.491910101935177,
    ],
    64: [
      0.0635, 0.0708592, 0.07756992, 0.084386879488, 0.0913871715172352,
      0.098674902258575, 0.10623478716619, 0.114209073818848, 0.122955341352326,
      0.132369011571947, 0.142500849813623, 0.153190618204143,
      0.167214542511886, 0.183451397042076, 0.200365467705563,
      0.218480411707899, 0.238773553325235, 0.263464867929986, 0.28907573994322,
      0.312886912137817, 0.338628324492571, 0.36731572712835, 0.395608942292759,
      0.42607221571141, 0.458871363745501, 0.494184830730253,
    ],
    65: [
      0.0646, 0.071824, 0.078719104, 0.085618804736, 0.0927077953830912,
      0.100656894556452, 0.108207718927848, 0.116486747655691,
      0.125397007705421, 0.135173439783217, 0.14570761999227, 0.155983715029745,
      0.171130034554176, 0.186908085546234, 0.20380635420513, 0.222736523624287,
      0.245769466352599, 0.269660205170914, 0.291872119531546,
      0.315884631056503, 0.34264526784361, 0.369038192437275, 0.397455425103927,
      0.428051645284982, 0.46099331224837, 0.49589087732656,
    ],
    66: [
      0.0661, 0.0730032, 0.079868288, 0.086850729984, 0.0942925440221184,
      0.10150631982697, 0.10927006679951, 0.117625584574113, 0.126617840881969,
      0.136669134829228, 0.147110581945428, 0.159636226263223,
      0.174354557412531, 0.190117867728666, 0.207776607858476,
      0.229262561896081, 0.251548698853464, 0.272268768219726,
      0.294668499119872, 0.31963177970486, 0.344252045184025, 0.370760657746201,
      0.399301907915095, 0.430031074858554, 0.462584773625522,
      0.498165606121636,
    ],
    67: [
      0.0677, 0.0743968, 0.081017472, 0.0882058477568, 0.0949528559550464,
      0.102214174219069, 0.11002888670784, 0.118601730504188, 0.127838674058517,
      0.137790906113736, 0.148914390170917, 0.162644176690794,
      0.177348757209576, 0.193821462554549, 0.213864330126941,
      0.234653636990172, 0.253982059906461, 0.274877331268537, 0.29816397360528,
      0.321130639164203, 0.345858822524441, 0.372483123055126,
      0.401148390726263, 0.431515647038734, 0.464706722128392,
      0.504421110308095,
    ],
    68: [
      0.0692, 0.0752544, 0.082166656, 0.088698617856, 0.09574523027456,
      0.103488312124847, 0.111850054487832, 0.12055402236434, 0.129931530932599,
      0.140408372444255, 0.151720314077233, 0.165437273516396,
      0.180803603129243, 0.199500307954236, 0.218893318087847,
      0.236923563345579, 0.256415420959457, 0.278138035079552,
      0.299562163399443, 0.322629498623546, 0.347465599864857,
      0.374205588364052, 0.40253325283464, 0.433495076612306, 0.470542080511283,
      0.511245296693323,
    ],
    69: [
      0.0698, 0.0762192, 0.0828561664, 0.089930543104, 0.0974620413001728,
      0.105328733544304, 0.113519458286158, 0.122506314224491,
      0.132373197285695, 0.143025838774773, 0.154325814847384,
      0.168660077545936, 0.186101033539399, 0.204191528067021,
      0.221010786702965, 0.239193489700986, 0.259457122275702,
      0.279442316603958, 0.300960353193606, 0.324128358082889,
      0.349072377205272, 0.375497437345746, 0.404379735645808,
      0.438938507939629, 0.476907926019891, 0.517500800879782,
    ],
    70: [
      0.0706, 0.0772912, 0.0841202688, 0.0916552384512, 0.0991788523257856,
      0.107169154963761, 0.115492390047816, 0.12494667904968, 0.134989268378298,
      0.145643305105292, 0.157532585026031, 0.173601710391231,
      0.190477171704311, 0.206166778640826, 0.223128255318084,
      0.242030897645244, 0.2606738028022, 0.280746598128364, 0.302358542987769,
      0.325627217542231, 0.350277460210584, 0.377219902654671, 0.40945756337652,
      0.444876796660346, 0.482743284402781, 0.522050258469934,
    ],
    71: [
      0.0715, 0.0779344, 0.0853843712, 0.0935031263232, 0.101555975284326,
      0.109859001653736, 0.119134725607799, 0.128688571781636,
      0.138826172647448, 0.150130390243324, 0.161941894021671,
      0.177683928828648, 0.1923197561948, 0.20814202921463, 0.225775091086981,
      0.243165860822947, 0.261890483328698, 0.28205087965277, 0.303756732781932,
      0.326751362136739, 0.351884237550999, 0.381956682254216,
      0.414997011810024, 0.450320227987669, 0.48698718140852, 0.522050258469934,
    ],
    72: [
      0.0721, 0.0794352, 0.0872230656, 0.0953510141952, 0.10353691108311,
      0.112407277465292, 0.121866477277787, 0.131454318583517,
      0.142139862698078, 0.153308742216097, 0.165749933608814,
      0.179402757644403, 0.194162340685289, 0.210611092431886, 0.22683382539454,
      0.244300824000651, 0.263107163855196, 0.283355161177176,
      0.304805375127555, 0.328250221596081, 0.356302875237142,
      0.387124078180993, 0.420074839540736, 0.454279087134813, 0.48698718140852,
      0.522050258469934,
    ],
    73: [
      0.0726, 0.0800784, 0.0880274944, 0.0959669768192, 0.104857534948966,
      0.11382298624949, 0.123080589131115, 0.133081228466977, 0.143535100614133,
      0.15517836102361, 0.167353318698137, 0.181121586460158, 0.196465571298401,
      0.211598717718788, 0.2278925597021, 0.245435787178354, 0.264323844381694,
      0.28433337232048, 0.306203564921718, 0.332372085109274, 0.361123207258388,
      0.391860857780537, 0.423767805163072, 0.454279087134813, 0.48698718140852,
      0.522050258469934,
    ],
    74: [
      0.0732, 0.0808288, 0.0888319232, 0.0970757095424, 0.105914034041651,
      0.114813982398428, 0.124446464966109, 0.134220065385398,
      0.145279148009202, 0.156674056069621, 0.168956703787461,
      0.183270122479851, 0.197386863543645, 0.21258634300569, 0.228951294009659,
      0.246570750356058, 0.265236354776567, 0.285637653844886,
      0.310048586855666, 0.336868663487303, 0.365541844944531,
      0.395305788398388, 0.423767805163072, 0.454279087134813, 0.48698718140852,
      0.522050258469934,
    ],
    75: [
      0.0739, 0.0815792, 0.089636352, 0.0983076347904, 0.106970533134336,
      0.116088120304206, 0.125660576819437, 0.135846975268858,
      0.146674385925256, 0.158169751115632, 0.170960935149115,
      0.184129536887729, 0.19830815578889, 0.213573968292592, 0.230010028317218,
      0.247421972739335, 0.266453035303065, 0.289224428037002,
      0.314243156238155, 0.340990527000496, 0.368755399625362,
      0.395305788398388, 0.423767805163072, 0.454279087134813, 0.48698718140852,
      0.522050258469934,
    ],
    76: [
      0.0746, 0.082544, 0.0906706176, 0.099169982464, 0.108159094613606,
      0.117220687331564, 0.127178216636096, 0.137148503175625,
      0.148069623841311, 0.160039369923145, 0.171762627693777,
      0.184988951295606, 0.199229448034134, 0.214561593579494,
      0.230804079047887, 0.248556935917038, 0.269798906750935, 0.29313727261022,
      0.318088178172104, 0.343988245919181, 0.368755399625362,
      0.395305788398388, 0.423767805163072, 0.454279087134813, 0.48698718140852,
      0,
    ],
    77: [
      0.0754, 0.0835088, 0.0915899648, 0.100401907712, 0.109215593706291,
      0.118636396115762, 0.128392328489424, 0.138450031082393, 0.14981367123638,
      0.16078721744615, 0.172564320238439, 0.185848365703483, 0.200150740279379,
      0.215302312544671, 0.231862813355446, 0.251678084655723,
      0.273448948330429, 0.296724046802336, 0.32088455776043, 0.343988245919181,
      0.368755399625362, 0.395305788398388, 0.423767805163072,
      0.454279087134813, 0, 0,
    ],
    78: [
      0.0763, 0.0842592, 0.0927391488, 0.1013874479104, 0.110536217572147,
      0.11976896314312, 0.129606440342752, 0.140239631954198, 0.150511290194407,
      0.161535064969156, 0.1733660127831, 0.186707780111361, 0.200841709463312,
      0.216289937831573, 0.234774332701234, 0.255082974188833,
      0.276794819778298, 0.299332609851148, 0.32088455776043, 0.343988245919181,
      0.368755399625362, 0.395305788398388, 0.423767805163072, 0, 0, 0,
    ],
    79: [
      0.0771, 0.0853312, 0.093658496, 0.1026193731584, 0.111592716664832,
      0.120901530170478, 0.131275844141078, 0.140890395907582,
      0.151208909152434, 0.162282912492161, 0.174167705327762,
      0.187352340917269, 0.201763001708557, 0.219005907370554,
      0.237950535623911, 0.258204122927517, 0.279228180831294,
      0.299332609851148, 0.32088455776043, 0.343988245919181, 0.368755399625362,
      0.395305788398388, 0, 0, 0, 0,
    ],
    80: [
      0.078, 0.0861888, 0.0946927616, 0.1036049133568, 0.112649215757517,
      0.122458809833095, 0.131731136086076, 0.141378468872619,
      0.151732123370955, 0.162843798134415, 0.174768974736258,
      0.188211755325146, 0, 0.22196878323126, 0, 0.260474049282924, 0,
      0.299332609851148, 0, 0.343988245919181, 0, 0, 0, 0, 0, 0,
    ],
  },
  // updated 4-28-25
  jointInflation: {
    50: [
      0.0388, 0.0424512, 0.0470016256, 0.0506321276928, 0.0552020775927808,
      0.0603091942068191, 0.066017332024704, 0.0715840348722124,
      0.0769124901225185, 0.0833849988150966, 0.0907916806829415,
      0.0999069249157455, 0.109403454122791, 0.119749566036887,
      0.130753686983551, 0.142721619596199, 0.155735107391746,
      0.169882668553865, 0.185609695175151, 0.203844886470626,
      0.220931884307134, 0.238992061613405, 0.261277317780282,
      0.283553286414214, 0.308743507167493, 0.333247768478629,
    ],
    51: [
      0.0395, 0.0432016, 0.0478060544, 0.0518640529408, 0.0573150757781504,
      0.061583332112597, 0.0670796798963659, 0.0727228717906339,
      0.0791797517361075, 0.0860024651456153, 0.0931967583169267,
      0.102055460935439, 0.111706684735902, 0.121971722932417,
      0.133135839175559, 0.145275286746032, 0.158472638576366,
      0.173143372364879, 0.190153812006181, 0.20609317565964, 0.222940355982654,
      0.24372884121295, 0.264508662699826, 0.288007002954751, 0.310865455670363,
      0.336091179472474,
    ],
    52: [
      0.0402, 0.043952, 0.0486104832, 0.0540815183872, 0.0591639491903488,
      0.0637068952888935, 0.0687490836946918, 0.075163236615823,
      0.0816214180892033, 0.0884329695953827, 0.0952009896785811,
      0.104203996955132, 0.113779592287702, 0.124193879827947,
      0.135517991367567, 0.147828953895864, 0.161514339892611,
      0.177382287319199, 0.192251096697425, 0.207966749983819,
      0.227358993668796, 0.246743155503569, 0.268663249024954,
      0.289986432528323, 0.313517891298949, 0.337228543870012,
    ],
    53: [
      0.041, 0.0452384, 0.0502193408, 0.0549438660608, 0.0599563235098624,
      0.0648394623162516, 0.0708737794380156, 0.0774409104526661,
      0.0840630844422992, 0.0904895502836474, 0.0972052210402354,
      0.106137679372856, 0.115852499839502, 0.126416036723476,
      0.137900143559575, 0.150666361840123, 0.16546855160373, 0.179338709605807,
      0.193998833940129, 0.212088613497011, 0.230170854014523,
      0.250618702448651, 0.270509731836122, 0.292460719495288,
      0.314578865550384, 0.340071954863857,
    ],
    54: [
      0.0419, 0.0470608, 0.0513685248, 0.0559294062592, 0.0608807602159616,
      0.066396741978869, 0.0726949472180074, 0.0797185842895093,
      0.0858071318373676, 0.0921722072104094, 0.0990090292657243,
      0.108071361790581, 0.117925407391303, 0.128638193619006,
      0.140546979328473, 0.154354992167659, 0.167293572393477,
      0.180969061511315, 0.197843855874078, 0.214711617550861,
      0.233786103030458, 0.252341167757577, 0.272817835350082,
      0.293450434282075, 0.317231301178971, 0.343484048056471,
    ],
    55: [
      0.0432, 0.0478112, 0.0521729536, 0.0567917539328, 0.06272963362816,
      0.0679540216414864, 0.0748196429613312, 0.0813454941729686,
      0.0873767744929292, 0.0938548641371715, 0.100812837491213,
      0.110005044208305, 0.119998314943103, 0.131107256836262, 0.14398786582804,
      0.156057436934214, 0.1688144230516, 0.184555835703431, 0.200290688013863,
      0.218084051334383, 0.235392880370874, 0.254494249393734,
      0.273741076755667, 0.29592472124904, 0.320414223933275, 0.346896141249084,
    ],
    56: [
      0.0446, 0.0486688, 0.0536668928, 0.0586396418048, 0.0644464446537728,
      0.0697944430609433, 0.0763372827779911, 0.0828097130680821,
      0.0889464171484908, 0.0955375210639335, 0.102616645716702,
      0.111938726626029, 0.122301545556214, 0.134317039018694,
      0.145575967289378, 0.157476140906343, 0.172160294499469,
      0.186838328371141, 0.20343661505073, 0.219582910793726, 0.237401352046393,
      0.255355482048196, 0.276049180269627, 0.298893865609398,
      0.323597146687579, 0.352582963236774,
    ],
    57: [
      0.0454, 0.0495264, 0.055735424, 0.0601179521024, 0.0660311932928,
      0.0755988490761536, 0.0811937301913026, 0.0872023697534224,
      0.0936553451151756, 0.10058549184422, 0.108028070393169,
      0.114087262645722, 0.125295745353259, 0.135798476949047,
      0.146899385173827, 0.160597289645027, 0.174289485420841,
      0.189772961801054, 0.204834804844893, 0.221456485117904,
      0.238204740716601, 0.257508563684353, 0.278818904486379,
      0.301863009969756, 0.328902017944752, 0.357132420826926,
    ],
    58: [
      0.0467, 0.0516704, 0.0573442816, 0.0624586100736, 0.0710495639830528,
      0.0768729869819314, 0.0825596060262965, 0.0886665886485358,
      0.0952249877707372, 0.102268148770982, 0.109831878618658,
      0.116880359471324, 0.126677683721126, 0.137033008557675,
      0.149810904519615, 0.162583475206008, 0.177027016605461, 0.19107724332546,
      0.206582542087597, 0.222205914847576, 0.24021321239212, 0.260092261647741,
      0.281588628703131, 0.306811583903687, 0.333145914950491,
      0.357132420826926,
    ],
    59: [
      0.0484, 0.0538144, 0.0590680576, 0.066523963392, 0.0722381254623232,
      0.0781471248877093, 0.0839254818612904, 0.0901308075436492,
      0.0967946304262988, 0.103950805697744, 0.111635686844147,
      0.11816948108314, 0.127829299027682, 0.139748978096656, 0.151663689557843,
      0.165137142355841, 0.178243697131959, 0.192707595230968,
      0.207281636984679, 0.224079489171754, 0.242623378402744, 0.26267595961113,
      0.286204835731051, 0.310770443050831, 0.333145914950491,
      0.357132420826926,
    ],
    60: [
      0.0508, 0.0560656, 0.062055936, 0.0676326961152, 0.0734266869415936,
      0.0798459754287465, 0.0857466496412822, 0.0920830994038005,
      0.098887487300381, 0.10619434826676, 0.114040764478132, 0.119243749092987,
      0.130362852702104, 0.141477322348734, 0.154045841749851,
      0.166272105533544, 0.179764547790082, 0.19335973599317, 0.209029374227383,
      0.226327778360768, 0.245033544413367, 0.266982122883443,
      0.289897801353387, 0.310770443050831, 0.333145914950491,
      0.357132420826926,
    ],
    61: [
      0.0523, 0.0575664, 0.0630902016, 0.0687414288384, 0.0748793731940352,
      0.0804122589424255, 0.0863537055679462, 0.0927338633571842,
      0.0995851062584083, 0.106942195789765, 0.114842457022794,
      0.121607138714649, 0.131975114131282, 0.143699479244264, 0.15510457605741,
      0.167690809505673, 0.180372888053331, 0.194990087898678,
      0.211126658918627, 0.228576067549783, 0.249050487764406,
      0.270427053501294, 0.289897801353387, 0.310770443050831,
      0.333145914950491, 0.357701103025695,
    ],
    62: [
      0.053, 0.0585312, 0.0641244672, 0.0699733540864, 0.0754076227403776,
      0.0809785424561046, 0.0869607614946101, 0.093384627310568,
      0.100282725216436, 0.10769004331277, 0.115644149567455, 0.123111113928435,
      0.134048021683082, 0.144687104531166, 0.156427993941859,
      0.168258291094525, 0.181893738711453, 0.196946510185287,
      0.213223943609872, 0.23232321619814, 0.252264042445237, 0.270427053501294,
      0.289897801353387, 0.310770443050831, 0.333676402076208,
      0.358269785224464,
    ],
    63: [
      0.0543, 0.059496, 0.0651587328, 0.0705893167104, 0.0760679346733056,
      0.0816863968482034, 0.08771958140294, 0.0941980822522977,
      0.10115474891397, 0.108624852716527, 0.116646265248283, 0.125044796346159,
      0.134969313928327, 0.145921636139794, 0.156957361095639,
      0.169676995066654, 0.1837187595012, 0.198902932471895, 0.21671941809528,
      0.235320935116825, 0.252264042445237, 0.270427053501294,
      0.289897801353387, 0.311265300444224, 0.334206889201926,
      0.359407149622002,
    ],
    64: [
      0.0545, 0.0604608, 0.0658482432, 0.0713284718592, 0.0767282466062336,
      0.0823942512403022, 0.08847840131127, 0.0950115371940273,
      0.102026772611504, 0.109559662120284, 0.11764838092911, 0.125904210754036,
      0.136120929234883, 0.146415448783245, 0.158280778980088,
      0.171379439833209, 0.185543780290947, 0.20216363628291, 0.219515797683606,
      0.235320935116825, 0.252264042445237, 0.270427053501294,
      0.290359422056179, 0.311760157837617, 0.33526786345336, 0.36054451401954,
    ],
    65: [
      0.0552, 0.061104, 0.0665377536, 0.0719444344832, 0.0773885585391616,
      0.0835268182676603, 0.0896925131645979, 0.0963130651007948,
      0.103422010527559, 0.111055357166295, 0.119251766018433,
      0.126978478763883, 0.136581575357505, 0.147649980391873,
      0.159868880441426, 0.173081884599764, 0.188585481607192,
      0.204772199331722, 0.219515797683606, 0.235320935116825,
      0.252264042445237, 0.270857669828525, 0.290821042758971,
      0.312749872624403, 0.336328837704795, 0.361681878417078,
    ],
    66: [
      0.0562, 0.0617472, 0.0671123456, 0.0725603971072, 0.0783129952452608,
      0.0840931017813394, 0.0902995690912618, 0.0969638290541786,
      0.104119629485586, 0.1118032046893, 0.120053458563095, 0.127408185967822,
      0.13773319066406, 0.149131418322226, 0.161456981902765, 0.175919292544023,
      0.191018842660188, 0.204772199331722, 0.219515797683606,
      0.235320935116825, 0.252665736780341, 0.271288286155757,
      0.291744284164555, 0.313739587411189, 0.33738981195623, 0.363387925013385,
    ],
    67: [
      0.0572, 0.0624976, 0.0676869376, 0.0731763597312, 0.078577120018432,
      0.0843762435381789, 0.0906030970545938, 0.0972892110308705,
      0.1044684389646, 0.112177128450803, 0.120454304835426, 0.128482453977668,
      0.139115129031927, 0.150612856252579, 0.164103817671663,
      0.178189218899429, 0.191018842660188, 0.204772199331722,
      0.219515797683606, 0.235695649981661, 0.253067431115445,
      0.272149518810219, 0.292667525570139, 0.314729302197975,
      0.338981273333382, 0.367937382603537,
    ],
    68: [
      0.0581, 0.0628192, 0.0681466112, 0.0731763597312, 0.078577120018432,
      0.0843762435381789, 0.0906030970545938, 0.0972892110308705,
      0.1044684389646, 0.112177128450803, 0.120454304835426, 0.129771575589484,
      0.140497067399794, 0.153081919469835, 0.166221286286781,
      0.178189218899429, 0.191018842660188, 0.204772199331722,
      0.219865345132147, 0.236070364846497, 0.253870819785652,
      0.273010751464682, 0.293590766975723, 0.316213874378155, 0.34322517033912,
      0.372486840193689,
    ],
    69: [
      0.0583, 0.063248, 0.068376448, 0.0736691298304, 0.07923743195136,
      0.0850840979302777, 0.0913619169629237, 0.0981026659726002,
      0.105340462662134, 0.113111937854559, 0.121456420516253,
      0.131060697201301, 0.142800298012906, 0.155057170043639,
      0.166221286286781, 0.178189218899429, 0.191018842660188,
      0.205098269712823, 0.220214892580687, 0.236819794576168, 0.25467420845586,
      0.273871984119145, 0.294975629084099, 0.320172733525299,
      0.347469067344859, 0.37760497998261,
    ],
    70: [
      0.0586, 0.063784, 0.0688361216, 0.074531477504, 0.0800298062708736,
      0.0859335232007963, 0.0922725008529196, 0.0990788119026758,
      0.106386891099175, 0.114233709139067, 0.122658959333245,
      0.133209233220994, 0.144642882503395, 0.155057170043639,
      0.166221286286781, 0.178189218899429, 0.191323012791813,
      0.205424340093925, 0.220913987477769, 0.23756922430584, 0.255477597126068,
      0.275163833100839, 0.298668594706436, 0.324131592672443,
      0.352243451476315, 0.381017073175224,
    ],
    71: [
      0.059, 0.063784, 0.0694107136, 0.0755170177024, 0.0810863053635584,
      0.0870660902281544, 0.0934866127062475, 0.100380339809443,
      0.10778212901523, 0.115729404185078, 0.124262344422569, 0.134928062036749,
      0.144642882503395, 0.155057170043639, 0.166221286286781,
      0.178472959693855, 0.191627182923437, 0.206076480856128, 0.22161308237485,
      0.238318654035511, 0.25668268013138, 0.27860876371869, 0.302361560328772,
      0.328585309212981, 0.355426374230619, 0.381017073175224,
    ],
    72: [
      0.059, 0.0645344, 0.0704449792, 0.0762561728512, 0.0821428044562432,
      0.0881986572555125, 0.0947007245595754, 0.101681867716211,
      0.109177366931285, 0.117225099231089, 0.125865729511892,
      0.134928062036749, 0.144642882503395, 0.155057170043639,
      0.166485969863671, 0.178756700488281, 0.192235523186686,
      0.206728621618331, 0.222312177271932, 0.239442798630018,
      0.259896234812211, 0.282053694336541, 0.3065161466539, 0.331554453573339,
      0.355426374230619, 0.381017073175224,
    ],
    73: [
      0.059, 0.0646416, 0.0703300608, 0.0761329803264, 0.0821428044562432,
      0.0881986572555125, 0.0947007245595754, 0.101681867716211,
      0.109177366931285, 0.117225099231089, 0.125865729511892,
      0.134928062036749, 0.144642882503395, 0.155304076365365,
      0.166750653440561, 0.179324182077133, 0.192843863449935,
      0.207380762380534, 0.223360819617554, 0.242440517548704,
      0.263109789493042, 0.285929241281623, 0.309285870870652,
      0.331554453573339, 0.355426374230619, 0.381017073175224,
    ],
    74: [
      0.0591, 0.0646416, 0.0704449792, 0.0761329803264, 0.0821428044562432,
      0.0881986572555125, 0.0947007245595754, 0.101681867716211,
      0.109177366931285, 0.117225099231089, 0.125865729511892,
      0.134928062036749, 0.144873205564706, 0.15555098268709, 0.16728002059434,
      0.179891663665984, 0.193452203713184, 0.208358973523838, 0.22615719920588,
      0.24543823646739, 0.266725038508977, 0.288512939245011, 0.309285870870652,
      0.331554453573339, 0.355426374230619, 0.381017073175224,
    ],
    75: [
      0.0591, 0.0646416, 0.0703300608, 0.0761329803264, 0.0821428044562432,
      0.0881986572555125, 0.0947007245595754, 0.101681867716211,
      0.109177366931285, 0.117225099231089, 0.125865729511892,
      0.135142915638718, 0.145103528626017, 0.156044795330541, 0.16780938774812,
      0.180459145254836, 0.194364714108058, 0.21096753657265, 0.228953578794207,
      0.248810670250911, 0.2691352045196, 0.288512939245011, 0.309285870870652,
      0.331554453573339, 0.355426374230619, 0.381017073175224,
    ],
    76: [
      0.0591, 0.0647488, 0.0703300608, 0.0761329803264, 0.0822748668428288,
      0.0883402281339323, 0.0948524885412414, 0.101844558704557,
      0.109351771670792, 0.11741206111184, 0.126066152648058, 0.135357769240687,
      0.145564174748639, 0.156538607973992, 0.168338754901899,
      0.181310367638114, 0.196798075161054, 0.213576099621462,
      0.232099505831074, 0.251058959439925, 0.2691352045196, 0.288512939245011,
      0.309285870870652, 0.331554453573339, 0.355426374230619, 0,
    ],
    77: [
      0.0592, 0.0647488, 0.0703300608, 0.0762561728512, 0.0824069292294144,
      0.088481799012352, 0.0950042525229074, 0.102007249692903,
      0.109526176410298, 0.117599022992591, 0.126266575784223,
      0.135787476444626, 0.146024820871261, 0.157032420617443,
      0.169132805632569, 0.18358029399352, 0.19923143621405, 0.216510733051375,
      0.234196790522318, 0.251058959439925, 0.2691352045196, 0.288512939245011,
      0.309285870870652, 0.331554453573339, 0, 0,
    ],
    78: [
      0.0592, 0.0647488, 0.0704449792, 0.076379365376, 0.0824069292294144,
      0.0886233698907718, 0.0953077804862393, 0.102332631669595,
      0.109874985889312, 0.117972946754094, 0.126667422056554,
      0.136217183648565, 0.146485466993884, 0.15777313958262, 0.171250274247687,
      0.185850220348927, 0.20196896739867, 0.218467155337984, 0.234196790522318,
      0.251058959439925, 0.2691352045196, 0.288512939245011, 0.309285870870652,
      0, 0, 0,
    ],
    79: [
      0.0592, 0.064856, 0.0705598976, 0.0765025579008, 0.082538991616,
      0.0889065116476113, 0.0956113084495713, 0.102658013646286,
      0.110223795368326, 0.118346870515597, 0.127068268328885,
      0.136646890852503, 0.147176436177817, 0.159748390156424,
      0.173367742862805, 0.18840388749876, 0.203793988188417, 0.218467155337984,
      0.234196790522318, 0.251058959439925, 0.2691352045196, 0.288512939245011,
      0, 0, 0, 0,
    ],
    80: [
      0.0593, 0.0649632, 0.070674816, 0.0766257504256, 0.0828031163891712,
      0.0891896534044508, 0.0959148364129033, 0.102983395622978,
      0.11057260484734, 0.118720794277099, 0.127469114601216, 0.137291451658412,
      0, 0.161723640730229, 0, 0.190106332265315, 0, 0.218467155337984, 0,
      0.251058959439925, 0, 0, 0, 0, 0, 0,
    ],
  },
}

export default scoreData
